import { MODES, TABS } from './constants';

type GetTabsOptions = {
  failedChecks: number;
  isLifecycleTabVisible: boolean;
  isSettingsTabVisible: boolean;
  isValidateTabVisible: boolean;
};

export function getTabs({
  failedChecks,
  isLifecycleTabVisible,
  isSettingsTabVisible,
  isValidateTabVisible,
}: GetTabsOptions) {
  return [
    {
      id: TABS.GUIDE,
      label: 'Guide',
      icon: 'navHelp' as const,
      isErrored: false,
    },
    isValidateTabVisible && {
      id: TABS.VALIDATE,
      label: 'Validate',
      icon: 'alertInfo' as const,
      isErrored: failedChecks >= 1,
      count: failedChecks,
    },
    isSettingsTabVisible && {
      id: TABS.SETTINGS,
      label: 'Settings',
      icon: 'navCog' as const,
      isErrored: false,
    },
    isLifecycleTabVisible && {
      id: TABS.VERSIONING,
      label: 'Versioning',
      icon: 'miscUptime' as const,
      isErrored: false,
    },
  ].filter(Boolean);
}

export function normalizeMode(mode: MODES) {
  return mode === MODES.PUBLISHING
    ? 'activate'
    : mode === MODES.PROMOTING
    ? 'promote'
    : undefined;
}
